const RoleRoutes = [
  // 角色管理
  {
    path: 'role',
    name: 'role',
    redirect: '/manage/system/role/list',
    component: () => import(/* webpackChunkName: "Role" */ '@/views/content'),
    meta: {
      sidebar: 2,
      authKey: ['auth_role'],
      title: 'com_sider_menu_role',
      disabled: false,
      icon: 'menu_role',

      breadcrumb: false,
    },
    children: [
      {
        path: 'list',
        name: 'RoleList',
        component: () => import(/* webpackChunkName: "RoleList" */ '@/views/system/role'),
        meta: {
          sidebar: false,
          authKey: ['auth_role', 'auth_role_list'],
          title: 'com_sider_menu_role',
          disabled: false,
          icon: 'menu_role',
        },
      },
      // 角色管理 - 菜单授权
      {
        path: 'auth/menu/:RoeId',
        name: 'RoleAuthMenu',
        component: () =>
          import(/* webpackChunkName: "RoleAuthMenu" */ '@/views/system/role/auth-menu'),
        meta: {
          sidebar: false,
          authKey: ['auth_role', 'auth_role_authMenu'],
          title: 'com_sider_menu_role_auth_menu',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 角色管理 - 数据授权
      {
        path: 'auth/data/:RoeId',
        name: 'RoleAuthData',
        component: () =>
          import(/* webpackChunkName: "RoleAuthData" */ '@/views/system/role/auth-data'),
        meta: {
          sidebar: false,
          systemMenu: true,
          authKey: ['auth_role', 'auth_role_authData'],
          title: 'com_sider_menu_role_auth_data',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
    ],
  },
];

export default RoleRoutes;
